var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgSendSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 283,
    height: 224,
    viewBox: "0 0 283 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "img-send-success-a",
    points: "0 0 167 0 167 167 0 167"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.22 .85)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9F1FF",
    fillRule: "nonzero",
    d: "M250.168037,199.118202 C273.592037,177.661202 292.360037,150.495202 277.397037,120.559202 C262.435037,90.623202 233.406037,92.808202 215.629037,65.421202 C193.408037,31.187302 205.947037,2.82870203 150.393037,0.161102032 C94.8390368,-2.50649797 64.2930368,28.305002 34.5157368,66.540202 C4.7387368,104.776202 -10.5940632,137.453202 8.2942368,185.248202 C27.1825368,233.042202 68.3470368,222.204202 85.5060368,217.124202 C129.061037,204.231202 145.616037,187.908202 166.830037,209.129202 C187.400037,229.707202 218.841037,227.815202 250.168037,199.118202 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.78 56.15)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "img-send-success-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#img-send-success-a"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#0375FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    mask: "url(#img-send-success-b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.444 23.158)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.203,
    x2: 12.213,
    y1: 56.782,
    y2: 56.782
  }), /*#__PURE__*/React.createElement("line", {
    x2: 12.214,
    y1: 101.421,
    y2: 101.421
  }), /*#__PURE__*/React.createElement("line", {
    x2: 28.172,
    y1: 77.654,
    y2: 77.654
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2592,120.684 L20.4612,120.684 C15.9312,120.684 12.2142,116.966 12.2142,112.425 L12.2142,43.724 C12.2142,39.183 15.9312,35.466 20.4612,35.466 L28.1722,35.466 M142.4322,102.863 L142.4782,102.863 L142.4782,112.425 C142.4782,116.966 138.7712,120.684 134.2312,120.684 L62.5582,120.684"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.442,
    x2: 76.049,
    y1: 94.457,
    y2: 63.717
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.836,
    x2: 102.166,
    y1: 94.457,
    y2: 63.033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1722,28.612 L42.5962,39.193 L76.0482,63.718 L85.6932,70.793 C89.1862,73.353 88.0872,73.353 91.5902,70.793 L102.1682,63.033 L123.6012,47.318"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.422,
    x2: 40.349,
    y1: 118.955,
    y2: 102.863
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.103,
    x2: 116.314,
    y1: 118.215,
    y2: 102.863
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.6552,0 C150.7082,0 162.1092,11.393 162.1092,25.459 C162.1092,39.516 150.7082,50.919 136.6552,50.919 C122.5922,50.919 111.2012,39.516 111.2012,25.459 C111.2012,11.393 122.5922,0 136.6552,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8372,46.6 L150.8372,94.457 C150.8372,99.081 147.0552,102.863 142.4322,102.863 L36.5672,102.863 C31.9542,102.863 28.1722,99.081 28.1722,94.457 L28.1722,25.968 C28.1722,21.353 31.9542,17.571 36.5672,17.571 L101.1502,17.571"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "127.213 27.411 133.5 32.784 146.093 18.126"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSendSuccess);
export default __webpack_public_path__ + "static/media/img-send-success.db63253caf6e27759dbe0239f4638add.svg";
export { ForwardRef as ReactComponent };